import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import 'normalize.css';
import 'index.css';
import { Root } from 'views/Root';
import { ReleaseVersionDomain } from 'models/ReleaseVersion';
import 'raf/polyfill';
import 'core-js/stable';
import 'intl';
import 'intl/locale-data/jsonp/en';
import 'regenerator-runtime/runtime.js';
import { shouldPolyfill } from '@formatjs/intl-relativetimeformat/should-polyfill';

async function polyfillForIntl() {
  if (!global.Intl) {
    // iOS 9系の場合Intlがサポートされていないため、intl packageを読み込む
    // TODO: Intl.DateTimeFormat などに対応していないので対応する
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    global.Intl = require('intl');
  }

  if (shouldPolyfill()) {
    // data 取得前に polyfill の import を行う
    import('@formatjs/intl-relativetimeformat/polyfill');
  }

  const polyfilled =
    global.Intl.RelativeTimeFormat != null &&
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (global.Intl.RelativeTimeFormat as any).polyfilled === true;

  if (polyfilled) {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    await require('@formatjs/intl-relativetimeformat/locale-data/en');
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    await require('@formatjs/intl-relativetimeformat/locale-data/ja');
  }
}

polyfillForIntl();

// 環境変数として SENTRY_DSN が設定されている場合のみ Sentry にエラーログを送信する
const sentryDsn = process.env.SENTRY_DSN;
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    release: ReleaseVersionDomain.currentVersion(),
    normalizeDepth: 10,
    ignoreErrors: [
      // TODO: zaloアプリの内部ブラウザで開いた場合に起きるエラーなので、webviewではnot safari判定になるようにする
      // https://app.clickup.com/t/
      // https://sentry.io/organizations/deploygatecom/issues/2293663428/?project=5394762
      "Can't find variable: zaloJSV2",
    ],
  });
}

ReactDOM.render(<Root />, document.getElementById('root'));
